var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFolderClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3A59",
    fillRule: "evenodd",
    d: "M7.304 12.002c-.205 0-.411-.044-.604-.135-.432-.204-.7-.609-.7-1.057V5.193c0-.45.268-.854.7-1.058.488-.23 1.067-.162 1.473.173l3.399 2.81c.273.223.428.546.428.883 0 .338-.155.66-.428.884l-3.4 2.809c-.245.203-.554.308-.868.308",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder_close.3156c47c.svg";
export { ForwardRef as ReactComponent };